export default "__VITE_ASSET__Vdan_aAr__"